'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _components = require('../../components');

var _Partners = require('./Partners.css');

var _Partners2 = _interopRequireDefault(_Partners);

var _lodash = require('lodash');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Partners = (_dec = (0, _reactCssModules2.default)(_Partners2.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(Partners, _Component);

  function Partners(props) {
    (0, _classCallCheck3.default)(this, Partners);
    return (0, _possibleConstructorReturn3.default)(this, (Partners.__proto__ || (0, _getPrototypeOf2.default)(Partners)).call(this, props));
  }

  (0, _createClass3.default)(Partners, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'renderImageCells',
    value: function renderImageCells(arr, lbl) {
      return arr.map(function (partner) {
        var img = _react2.default.createElement('img', {
          styleName: 'logo',
          src: require('../../../static/images/p_' + partner.short_name + '.jpg'),
          alt: partner.long_name
        });
        return _react2.default.createElement(
          'div',
          {
            styleName: lbl + '-cell',
            key: partner.short_name
          },
          /* if there is a link, wrap the image in a link */
          partner.link ? _react2.default.createElement(
            _components.Link,
            { to: partner.link, title: partner.long_name },
            img
          ) : img
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var funderImages = this.renderImageCells(_config2.default.funders, 'funder');
      var partnersList = (0, _lodash.orderBy)(_config2.default.partners, ['short_name'], ['asc']);
      var partnerImages = this.renderImageCells(partnersList, 'logo');

      return _react2.default.createElement(
        'div',
        { styleName: 'page' },
        _react2.default.createElement(
          'div',
          { styleName: 'container' },
          _react2.default.createElement(
            'div',
            { styleName: 'container-inner' },
            _react2.default.createElement(_reactHelmet2.default, { title: 'Partners' }),
            _react2.default.createElement(
              'div',
              { styleName: 'headline' },
              'Partners'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'lede' },
              'Thanks to the following organizations and businesses for helping spread the word about Gender Equality Funds. Together, we\u2019re moving the needle on gender equality in the workplace.'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'tagline' },
              'Interested in becoming a partner?'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'lede' },
              'Contact Stefanie Spear, Communications Director \xA0 \xA0',
              _react2.default.createElement(
                _components.Link,
                { to: _config2.default.links.contactStefanie, xstrong: true },
                'Email',
                _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-envelope-o' })
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'logos' },
              funderImages,
              partnerImages
            )
          )
        ),
        _react2.default.createElement(_components.GetStartedInput, null)
      );
    }
  }]);
  return Partners;
}(_react.Component)) || _class);
exports.default = Partners;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Partners/Partners.js
// module id = 1313
// module chunks = 0